var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"text-center",attrs:{"title":_vm.titulo}},[_c('vue-apex-chart',{attrs:{"type":_vm.tipo,"options":_vm.options,"series":_vm.series,"height":"300"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }